import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';
import scrollLock from 'scroll-lock';
gsap.registerPlugin(Flip);

let view = null;

class Artists {
	constructor(container) {
		this.container = container;
	}

	init() {
		this.modal = document.querySelector('[data-artist-modal]');
		this.modalImageContainer = this.modal.querySelector('[data-modal-image]');
		this.modalImage = this.modalImageContainer.querySelector('img');
		this.modalTitle = this.modal.querySelector('[data-modal-title]');
		this.modalDescription = this.modal.querySelector('[data-modal-description]');
		this.modalSoundcloud = this.modal.querySelector('[data-modal-soundcloud]');
		this.modalInstagram = this.modal.querySelector('[data-modal-instagram]');
		this.modalContent = this.modal.querySelector('[data-modal-content]');
		this.isModalOpen = false;

		this.backdrop = document.querySelector('[data-backdrop]');
		this.artist = null;

		const artists = document.querySelectorAll('[data-artist]');
		artists.forEach((artist) => {
			artist.addEventListener('click', (e) => {
				this.openModal(artist);
			});
		});

		document.querySelector('[data-modal-close]').addEventListener('click', (e) => {
			this.closeModal();
		});

		this.backdrop.addEventListener('click', () => {
			this.closeModal();
		});

		document.addEventListener('keydown', (evt) => {
			evt = evt || window.event;
			if (evt.key == 'Escape') {
				this.closeModal();
			}
		});
	}

	openModal(artist) {
		this.currentArtistImg = artist.querySelector('img');
		scrollLock.disablePageScroll();

		let onLoad = () => {
			this.fillModalMeta(artist);

			Flip.fit(this.modalImageContainer, this.currentArtistImg, { scale: true });
			const state = Flip.getState(this.modalImageContainer);

			gsap.set(this.modalImageContainer, { clearProps: true });
			this.modal.classList.add('is-active');

			Flip.from(state, {
				duration: 0.7,
				ease: 'expo.inOut',
				scale: true,
				onComplete: () => {
					this.modal.classList.add('visible');
				},
			});

			gsap.to(this.backdrop, {
				duration: 0.7,
				autoAlpha: 1,
				ease: 'power1.inOut',
			});

			this.modalImage.removeEventListener('load', onLoad);
		};

		this.modalImage.addEventListener('load', onLoad);
		this.modalImage.src = this.currentArtistImg.src;
		this.modalImage.srcset = this.currentArtistImg.srcset;

		this.isModalOpen = true;
	}

	closeModal() {
		if (!this.isModalOpen) {
			return;
		}

		this.modalContent.scrollTop = 0;
		this.modal.classList.remove('visible');

		gsap.to(this.backdrop, {
			duration: 0.4,
			autoAlpha: 0,
			ease: 'expo.inOut',
		});

		const state = Flip.getState(this.modalImage);
		Flip.fit(this.modalImage, this.currentArtistImg, { scale: true });
		Flip.from(state, {
			duration: 0.7,
			ease: 'expo.inOut',
			scale: true,
			delay: 0.3,
			onComplete: () => {
				this.modal.classList.remove('is-active');
				gsap.set(this.modalImage, { clearProps: true });
				scrollLock.enablePageScroll();
			},
		});
		this.currentArtistImg = null;
		this.clearModalMeta();
	}

	fillModalMeta(artist) {
		this.modalTitle.innerHTML = artist.dataset.title;
		this.modalDescription.innerHTML = artist.dataset.description;
		if (artist.dataset.soundcloud.length > 0) {
			this.modalSoundcloud.href = artist.dataset.soundcloud;
			this.modalSoundcloud.classList.add('is-active');
		}
		if (artist.dataset.instagram.length > 0) {
			this.modalInstagram.href = artist.dataset.instagram;
			this.modalInstagram.classList.add('is-active');
		}
	}

	clearModalMeta() {
		this.modalTitle.innerHTML = '';
		this.modalDescription.innerHTML = '';
		this.modalSoundcloud.href = '';
		this.modalInstagram.href = '';
		this.modalSoundcloud.classList.remove('is-active');
		this.modalInstagram.classList.remove('is-active');
	}
}

export default {
	namespace: 'template-artists',
	beforeEnter: ({ current, next, trigger }) => {
		view = new Artists(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view = null;
	},
};
